import React from 'react';
import { action, makeObservable } from 'mobx';
import { BaasicAsyncCreatableSelectTemplate } from 'themes/components';
import { isSome } from 'core/utils';
import _ from 'lodash';

class BaasicAsyncCreatableSelect extends React.Component {
	constructor(props) {
		super(props);
		makeObservable(this);
		this.service = props.service;
		this.isLoading = true;
		this.field = props.field;
		this.selectedValue = props.selectedValue;
		this.creatable = props.creatable || false;
		this.multi = props.multi || false;
		this.searchBy = props.searchBy || 'name';
		this.prevOnChange = props.onChange;
		this.onValueClick = props.onValueClick;
		this.createMode = props.createMode;
		this.isLookup = props.isLookup;
		this.options = props.options;
		this.lookupName = props.lookupName;
		this.warehouseOnly = props.warehouseOnly;
		this.includeOnlySellerWarehouses = props.includeOnlySellerWarehouses;
		this.getRef = props.getRef;
		this.ids = props.ids;
		this.isDisabled = props.isDisabled;
		this.updateDataItem = props.updateDataItem;
		this.arrayIdx = props.arrayIdx;
		this.sellerWarehousesOnlyOrganizationId = props.sellerWarehousesOnlyOrganizationId;
		this.idsToExclude = props.idsToExclude && props.idsToExclude();
	}

	@action.bound
	findItemsAsync = async inputValue => {
		let filter = {
			search: inputValue || null,
			pageNumber: 1,
			pageSize: 50,
			orderBy: this.searchBy,
			orderDirection: 'asc',
			searchFields: this.searchBy,
			embed: this.options,
			warehouseOnly: this.warehouseOnly,
			ids: this.ids,
			idsToExclude: this.idsToExclude,
		};
		if (this.includeOnlySellerWarehouses && this.sellerWarehousesOnlyOrganizationId) {
			filter.includeOnlySellerWarehouses = this.includeOnlySellerWarehouses;
			filter.sellerWarehousesOnlyOrganizationId = this.sellerWarehousesOnlyOrganizationId;
		}
		let response;
		if (!this.isDisabled) {
			if (isSome(this.isLookup) && isSome(this.lookupName)) {
				await this.service.find(filter, this.lookupName);
				response = this.service.response.item;
			} else {
				response = (await this.service.find(filter)).data.item;
			}
			response = _.orderBy(response, this.searchBy, 'asc');
			this.isLoading = false;
			return _.map(response, item => {
				return {
					value: item.id,
					label: item[this.searchBy],
					extra: item,
				};
			});
		}
	};

	loadOptions = async inputValue => {
		return await this.findItemsAsync(inputValue);
	};

	@action.bound onBlur() {
		if (isSome(this.field)) {
			if (_.isEmpty(this.field.value)) {
				this.field.reset();
			}
		} else if (this.selectedValue) {
			if (_.isEmpty(this.selectedValue)) {
				this.selectedValue = null;
			}
		}
	}

	@action.bound onChange(selectedValue) {
		if (isSome(this.field)) {
			this.field.set('value', selectedValue);
		} else if (this.selectedValue !== undefined) {
			this.selectedValue = [{ value: selectedValue.value, label: selectedValue.label, extra: selectedValue.extra }];
			this.updateDataItem(this.arrayIdx, selectedValue);
		}
		if (this.prevOnChange) this.prevOnChange(selectedValue);
	}

	@action.bound handleCloseMenuOnScroll = () => {
		// forcing select menu re-rendering on scroll
		this.setState({ top: 0 });
		// as expected do not close the menu on scroll
		return false;
	};
	render() {
		return (
			<BaasicAsyncCreatableSelectTemplate
				className={`react-dropdown ${isSome(this.field && this.field.error) ? 'input--invalid' : ''}`}
				isLoading={this.isLoading}
				onChange={this.onChange}
				onBlur={this.onBlur}
				placeholder={this.field && this.field.placeholder}
				menuPortalTarget={document.body}
				styles={{ menuPortal: base => ({ ...base, zIndex: 99 }) }}
				value={this.field ? this.field : this.selectedValue}
				loadOptions={this.loadOptions}
				creatable={this.creatable}
				components={{ LoadingIndicator: () => null }}
				multi={this.multi}
				onValueClick={this.onValueClick}
				field={this.field}
				autoFocus={this.props.autoFocus}
				disabled={this.props.readOnly}
				createMode={this.createMode}
				isDisabled={this.isDisabled}
				getRef={this.getRef}
				menuPlacement={'auto'}
				closeMenuOnScroll={this.handleCloseMenuOnScroll}
				isClearable={this.field && !(this.field.$rules && this.field.$rules.includes('required'))}
				cacheOptions
				defaultOptions
				classNamePrefix="react-select"
			/>
		);
	}
}

export default BaasicAsyncCreatableSelect;
